import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import { domElementIds } from "@shared/constants/common";
import { useSeatingHeight } from "@shared/hooks/seating/useSeatingHeight";
import { useBasketService } from "@shared/modules/basket/context/BasketServiceContext";
import { useSeatingState } from "@shared/modules/seating/contexts/useSeatingState";
import { Spinner } from "@ui-kit/feedback/Spinner/Spinner.web";
import BestAvailableSeating from "../../features/BestAvailable/components/BestAvailableSeating.web";
import { type SidebarSeatingContainerProps } from "./SidebarSeatingContainer.props";

export default function SidebarSeatingContainer({
  bestAvailableSeating,
  cartComponent,
  onContinue,
  isLoading,
  disableBestAvailableSeating,
  onOpenTypeQuantitySelect,
  hideCheckoutButton = false,
  basketFooter,
}: SidebarSeatingContainerProps) {
  const { areAllRenewalItemGroups } = useBasketService();
  const { isSeatingBasketUpdating } = useSeatingState();

  const containerHeight = useSeatingHeight({
    format: "calc",
    defaultValue: "100%",
  });

  if (disableBestAvailableSeating || areAllRenewalItemGroups) {
    return <>{cartComponent}</>;
  }

  return (
    <Flex
      id={domElementIds.bestAvailableSeatingId}
      direction="column"
      width="100%"
      height={containerHeight}
      overflow="hidden"
    >
      {!isSeatingBasketUpdating && (
        <BestAvailableSeating
          bestAvailableSeating={bestAvailableSeating}
          isLoading={isLoading}
          onContinue={onContinue}
          onOpenTypeQuantitySelect={onOpenTypeQuantitySelect}
          hideCheckoutButton={hideCheckoutButton}
          basketFooter={basketFooter}
        />
      )}
      {isSeatingBasketUpdating && (
        <Flex width="100%" flex="1" alignItems="center" justifyContent="center">
          <Spinner
            color="primary.600"
            emptyColor="gray.400"
            speed="0.65s"
            size="3xl"
            thickness="10px"
          />
        </Flex>
      )}
    </Flex>
  );
}
